
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacyPolicy",
      function () {
        return require("private-next-pages/privacyPolicy.js");
      }
    ]);
  